import MemberCardVue from '@/views/sa/member-search/member-search.vue';

const basePath = '/sa/member-search';
const role = 'sa'; // 角色身份

export const SA_MEMBER_SEARCH_INDEX = 'sa-member-search-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: MemberCardVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_MEMBER_SEARCH_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "member-search" */
        `@/views/${role}/member-search/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
